import {
  CalendarFilterOption,
  PreDefinedGranularityFilterOption,
} from 'types/types';
import UserManager from 'utils/UserManager';

export enum CalendarView {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
}

export interface Option {
  value: string;
  label: string;
}

export interface CustomGranularityFilter {
  startTime: { hour: number; minute: number };
  endTime: { hour: number; minute: number };
}

export const calendarFilterOptions: { [key: string]: CalendarFilterOption[] } =
  {
    // RAW: [
    //   {
    //     label: 'Last 15 min',
    //     value: 'MI:15',
    //     getDates: function () {
    //       return getDatesFromTime(15);
    //     },
    //   },
    //   {
    //     label: 'Last 30 Min',
    //     value: 'MI:30',
    //     getDates: function () {
    //       return getDatesFromTime(30);
    //     },
    //   },
    //   {
    //     label: 'Last 45 Min',
    //     value: 'MI:45',
    //     getDates: function () {
    //       return getDatesFromTime(45);
    //     },
    //   },
    //   {
    //     label: 'Last 24 Hours',
    //     value: 'H:24',
    //     getDates: function () {
    //       return getDatesFromHours(-24);
    //     },
    //   },
    // ],
    // '5MIN': [
    //   {
    //     label: 'Last 15 min',
    //     value: 'MI:15',
    //     getDates: function () {
    //       return getDatesFromTime(15);
    //     },
    //   },
    //   {
    //     label: 'Last 30 Min',
    //     value: 'MI:30',
    //     getDates: function () {
    //       return getDatesFromTime(30);
    //     },
    //   },
    //   {
    //     label: 'Last 45 Min',
    //     value: 'MI:45',
    //     getDates: function () {
    //       return getDatesFromTime(45);
    //     },
    //   },
    //   {
    //     label: 'Last 24 Hours',
    //     value: 'H:24',
    //     getDates: function () {
    //       return getDatesFromHours(-24);
    //     },
    //   },
    // ],
    '15MIN': [
      {
        label: 'Last 15 min',
        value: 'MI:15',
        getDates: function () {
          return getDatesFromTime(15);
        },
      },
      {
        label: 'Last 30 Min',
        value: 'MI:30',
        getDates: function () {
          return getDatesFromTime(30);
        },
      },
      {
        label: 'Last 45 Min',
        value: 'MI:45',
        getDates: function () {
          return getDatesFromTime(45);
        },
      },
      {
        label: 'Last Hour',
        value: 'H:1',
        getDates: function () {
          return getDatesFromHours(-1);
        },
      },
      {
        label: 'Today',
        value: 'L:0',
        getDates: function () {
          return initDates();
        },
      },
    ],
    '30MIN': [
      {
        label: 'Last 30 Min',
        value: 'MI:30',
        getDates: function () {
          return getDatesFromTime(30);
        },
      },
      {
        label: 'Last Hour',
        value: 'H:1',
        getDates: function () {
          return getDatesFromHours(-1);
        },
      },
      {
        label: 'Last 90 Min',
        value: 'MI:90',
        getDates: function () {
          return getDatesFromTime(90);
        },
      },
      {
        label: 'Today',
        value: 'L:0',
        getDates: function () {
          return initDates();
        },
      },
    ],
    HOURLY: [
      {
        value: 'H:0',
        label: 'Current',
        getDates: function () {
          var dates = {
            dateFrom: new Date(),
            dateTo: new Date(),
          };
          dates.dateFrom.setMinutes(0);

          dates.dateTo.setHours(dates.dateFrom.getHours() + 1);
          dates.dateTo.setMinutes(0);

          return dates;
        },
      },
      {
        label: 'Last Hour',
        value: 'H:1',
        getDates: function () {
          return getDatesFromHours(-1);
        },
      },
      {
        label: 'Last Two Hours',
        value: 'H:2',
        getDates: function () {
          return getDatesFromHours(-2);
        },
      },
      {
        label: 'Last Three Hours',
        value: 'H:3',
        getDates: function () {
          return getDatesFromHours(-3);
        },
      },
      {
        label: 'Last 24 Hours',
        value: 'H:24',
        getDates: function () {
          return getDatesFromHours(-24);
        },
      },
      {
        value: 'PH:13',
        label: 'Peak hours (13-14)',
        getDates: function () {
          return getPeakHourDates(13, 14);
        },
      },
      {
        value: 'PH:20',
        label: 'Peak hours (20-21)',
        getDates: function () {
          return getPeakHourDates(20, 21);
        },
      },
      {
        value: 'PH:23',
        label: 'Peak hours (23-00)',
        getDates: function () {
          return getPeakHourDates(23, 24);
        },
      },
      {
        value: 'L:30',
        label: 'Last 30 days',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setDate(dates.dateFrom.getDate() - 30);
          return dates;
        },
      },
    ],
    DAILY: [
      {
        value: 'L:1',
        label: 'Yesterday',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setDate(dates.dateFrom.getDate() - 1);
          dates.dateTo.setDate(dates.dateTo.getDate() - 1);
          return dates;
        },
      },
      {
        label: 'Today',
        value: 'L:0',
        getDates: function () {
          return initDates();
        },
      },
      {
        value: 'L:7',
        label: 'Last 7 days',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setDate(dates.dateFrom.getDate() - 7);
          return dates;
        },
      },
      {
        value: 'L:15',
        label: 'Last 15 days',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setDate(dates.dateFrom.getDate() - 15);
          return dates;
        },
      },
      {
        value: 'L:30',
        label: 'Last 30 days',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setDate(dates.dateFrom.getDate() - 29);
          return dates;
        },
      },
    ],
    WEEKLY: [
      {
        value: 'W:0',
        label: 'This Week',
        getDates: function () {
          const today = new Date();
          const dayOfWeek = today.getDay();
          const startOfWeek = new Date(today);
          startOfWeek.setDate(today.getDate() - dayOfWeek);
          const endOfWeek = new Date(today);
          endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));
          return {
            dateFrom: startOfWeek,
            dateTo: endOfWeek,
          };
        },
      },
      {
        value: 'W:1',
        label: 'Last Week',
        getDates: function () {
          return getLastWeeksDates(1);
        },
      },
      {
        value: 'W:2',
        label: 'Last Two Weeks',
        getDates: function () {
          return getLastWeeksDates(2);
        },
      },
      {
        value: 'W:4',
        label: 'Last Four Weeks',
        getDates: function () {
          return getLastWeeksDates(4);
        },
      },
    ],
    MONTHLY: [
      {
        value: 'M:0',
        label: 'This Month',
        getDates: function () {
          return {
            dateFrom: new Date(),
            dateTo: new Date(),
          };
        },
      },
      {
        value: 'M:1',
        label: 'Last Month',
        getDates: function () {
          var date = new Date();
          date.setMonth(date.getMonth() - 1);
          return {
            dateFrom: date,
            dateTo: date,
          };
        },
      },
      {
        value: 'H:1',
        label: 'H1',
        getDates: function () {
          const year = new Date().getFullYear();
          const startOfFirstHalf = new Date(year, 0, 1);

          const endOfFirstHalf = new Date(year, 5, 30);

          return {
            dateFrom: startOfFirstHalf,
            dateTo: endOfFirstHalf,
          };
        },
      },
      {
        value: 'H:2',
        label: 'H2',
        getDates: function () {
          const year = new Date().getFullYear();

          const startOfSecondHalf = new Date(year, 6, 1);
          const endOfSecondHalf = new Date(year, 11, 31);

          return {
            dateFrom: startOfSecondHalf,
            dateTo: endOfSecondHalf,
          };
        },
      },
      {
        value: 'Y:0',
        label: 'This Year',
        getDates: function () {
          var dates = initDates();
          dates.dateFrom.setMonth(0);
          dates.dateTo.setMonth(11);
          return dates;
        },
      },
    ],
  };

export const allAvailableGranularities = [
  'raw',
  '5min',
  '15min',
  '30min',
  'hourly',
  'daily',
  'weekly',
  'monthly',
];

export const granularityOptions: PreDefinedGranularityFilterOption[] = [
  // {
  //   label: 'Raw',
  //   value: 'raw',
  //   calendarView: CalendarView.DAY,
  //   showSpecificAndCustomFilters: true,
  //   hiddenFilterOptions: [],
  //   defaultValue: 'MI:30',
  //   maxDays: 2,
  // },
  // {
  //   label: '5 Minutes',
  //   value: '5min',
  //   calendarView: CalendarView.DAY,
  //   showSpecificAndCustomFilters: true,
  //   hiddenFilterOptions: [],
  //   defaultValue: 'MI:15',
  //   maxDays: 2,
  // },
  {
    label: '15 Minutes',
    value: '15min',
    calendarView: CalendarView.DAY,
    showSpecificAndCustomFilters: true,
    hiddenFilterOptions: [],
    defaultValue: 'MI:15',
    maxDays: 2,
  },
  {
    label: 'Hourly',
    value: 'hourly',
    showSpecificAndCustomFilters: true,
    calendarView: CalendarView.DAY,
    hiddenFilterOptions: [],
    defaultValue: 'H:0',
    maxDays: 5,
  },
  {
    label: 'Daily',
    value: 'daily',
    showSpecificAndCustomFilters: false,
    calendarView: CalendarView.DAY,
    hiddenFilterOptions: [],
    defaultValue: 'L:1',
    maxDays: 30,
  },
  {
    label: 'Weekly',
    value: 'weekly',
    showSpecificAndCustomFilters: false,
    calendarView: CalendarView.DAY,
    hiddenFilterOptions: [],
    defaultValue: 'W:0',
  },
  {
    label: 'Monthly',
    value: 'monthly',
    showSpecificAndCustomFilters: false,
    calendarView: CalendarView.MONTH,
    hiddenFilterOptions: [],
    defaultValue: 'M:0',
  },
];

export const hoursOptions: Option[] = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
];

export const minutesOptions: Option[] = [
  {
    value: '0',
    label: '0',
  },
  {
    value: '15',
    label: '15',
  },
  {
    value: '30',
    label: '30',
  },
  {
    value: '45',
    label: '45',
  },
];

export const initDates = (): {
  dateFrom: Date;
  dateTo: Date;
} => {
  var from = new Date();
  from.setHours(0, 0, 0, 0);
  var to = new Date(from);

  return { dateFrom: from, dateTo: to };
};

export const getDatesFromTime = (
  timeToCalculate: number
): {
  dateFrom: Date;
  dateTo: Date;
} => {
  var dates = {
    dateFrom: new Date(),
    dateTo: new Date(),
  };
  var minutes = Math.trunc(dates.dateFrom.getMinutes() / 15) * 15;
  dates.dateFrom.setMinutes(minutes - timeToCalculate);
  dates.dateTo.setMinutes(minutes);

  return dates;
};

export const getDatesFromHours = (
  hoursToCalculate: number
): {
  dateFrom: Date;
  dateTo: Date;
} => {
  var dates = {
    dateFrom: new Date(),
    dateTo: new Date(),
  };
  dates.dateFrom.setHours(dates.dateFrom.getHours() + hoursToCalculate);
  dates.dateFrom.setMinutes(0);
  dates.dateTo.setMinutes(0);

  return dates;
};

export const getPeakHourDates = (
  fromHour: number,
  toHour: number
): {
  dateFrom: Date;
  dateTo: Date;
} => {
  var dates = {
    dateFrom: new Date(),
    dateTo: new Date(),
  };
  dates.dateFrom.setHours(fromHour);
  dates.dateFrom.setMinutes(0);
  dates.dateTo.setHours(toHour);
  dates.dateTo.setMinutes(0);

  return dates;
};

export const getLastWeeksDates = (
  numberOfWeeks: number
): {
  dateFrom: Date;
  dateTo: Date;
} => {
  const today = new Date();
  const dayOfWeek = today.getDay();

  const startOfLastNWeeks = new Date(today);

  const endOfLastNWeeks = new Date(today);
  endOfLastNWeeks.setDate(
    today.getDate() - dayOfWeek - 7 * (numberOfWeeks - 1) - 1
  );

  return {
    dateFrom: startOfLastNWeeks,
    dateTo: endOfLastNWeeks,
  };
};

export const getLocalDateFromUnix = (
  timestamp: string | number,
  targetTimeZone?: string
) => {
  const timestampParsed =
    typeof timestamp === 'number' ? timestamp : parseFloat(timestamp);
  if (isNaN(timestampParsed)) {
    return '';
  }
  // Convert Unix timestamp to milliseconds
  const timestampInMilliseconds = timestampParsed * 1000;

  // Create a Date object with the timestamp
  const date = new Date(timestampInMilliseconds);

  // Create a formatter with the target time zone
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: targetTimeZone,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  });

  // Format the date using the target time zone
  const localDate = formatter.format(date);

  return localDate;
};

export const getTimeZoneIdentifier = (): string | undefined => {
  try {
    // Use try-catch to handle cases where the browser doesn't support the Intl API
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone;
  } catch (error) {
    console.error('Error fetching time zone:', error);
    return undefined;
  }
};

export const getDateRange = (
  daysFrom: number,
  daysTo: number
): { dateFrom: Date; dateTo: Date } => {
  const today = new Date();

  const dateFrom = new Date(today);
  dateFrom.setDate(today.getDate() - daysFrom);

  const dateTo = new Date(today);
  dateTo.setDate(today.getDate() - daysTo);

  return {
    dateFrom,
    dateTo,
  };
};

export const getMonthRange = (
  monthsFrom: number,
  monthsTo: number
): { dateFrom: Date; dateTo: Date } => {
  const today = new Date();

  // Calculate the start date by subtracting `monthsFrom` months
  const dateFrom = new Date(today);
  dateFrom.setMonth(today.getMonth() - monthsFrom);

  // Calculate the end date by subtracting `monthsTo` months
  const dateTo = new Date(today);
  dateTo.setMonth(today.getMonth() - monthsTo);

  return {
    dateFrom,
    dateTo,
  };
};

export const getWeekRange = (
  weeksFrom: number,
  weeksTo: number
): { dateFrom: Date; dateTo: Date } => {
  const today = new Date();

  // Calculate the start date by subtracting `weeksFrom` weeks (7 days per week)
  const dateFrom = new Date(today);
  dateFrom.setDate(today.getDate() - weeksFrom * 7);

  // Calculate the end date by subtracting `weeksTo` weeks (7 days per week)
  const dateTo = new Date(today);
  dateTo.setDate(today.getDate() - weeksTo * 7);

  return {
    dateFrom,
    dateTo,
  };
};

export const validateDateRange = (
  startDate: Date,
  endDate: Date,
  maxDays?: number
): { dateFrom: Date; dateTo: Date } => {
  if (maxDays && startDate && endDate) {
    const selectedDaysRange = Math.round(
      Math.abs(
        (endDate.getTime() - startDate.getTime()) / (24 * 60 * 60 * 1000)
      )
    );

    if (selectedDaysRange >= maxDays) {
      const newData = new Date(startDate);
      newData.setDate(newData.getDate() + maxDays - 1);
      endDate = newData;
    }
  }
  return { dateFrom: startDate, dateTo: endDate };
};

// eslint-disable-next-line no-undef
export const getBrowserDateShiftedToUserTZ = (date: Date) => {
  const userProps = UserManager.getProperties();
  const userTimeZone =  userProps["timeZone"];// "Asia/Beirut";// userProps["timezone"]; "America/Argentina/Cordoba";
  const tz = date.toLocaleString("en", {timeZone : userTimeZone, timeStyle: "long"}).split(" ").slice(-1)[0];
  const dateString = date.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false //24-hour format
  });
  const userTimezoneOffset = -(Date.parse(`${dateString} UTC`) - Date.parse(`${dateString} ${tz}`));
  const browserTimezoneOffset = -(date.getTimezoneOffset() * 60000);
  const nd = new Date(date.getTime() + browserTimezoneOffset + userTimezoneOffset );
  return nd;
}

export const getFormattedValue = (date: Date, aggr?: string) => {
  const format = getDateFormatByAggr(aggr);
  return intlDateTimeFormat(date, format.format, format.includeTime);
};

export const getDateFormatByAggr = (
  aggr?: string
): { format: string; includeTime: boolean } => {
  aggr = aggr || 'raw';
  const userProps = UserManager.getProperties();
  let format = userProps['dateDisplayFormat'];
  let includeTime = true;
  switch (aggr.toLowerCase()) {
    case 'raw':
    case '5min':
    case '15min':
    case '30min':
    case 'hourly':
      format = `${format} HH:mm:ss`;
      includeTime = true;
      break;
    case 'daily':
    case 'weekly':
      format = `${format}`;
      includeTime = false;
      break;
    case 'monthly':
      includeTime = false;
      format = 'yyyy-MM';
      break;
  }
  return { format, includeTime };
};

export const intlDateTimeFormat = (
  d: Date,
  formatString: string,
  includeTime = true
) => {
  if (!d) return '';
  const userProps = UserManager.getProperties();
  const userTimeZone = userProps['timeZone']; // "Asia/Beirut";// userProps["timezone"]; "America/Argentina/Cordoba";

  const dateToFormat = new Date(d);
  //INTL datetime formater used ONLY for TIME part
  const timeintlformater = new Intl.DateTimeFormat(undefined, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZoneName: 'short',
    timeZone: userTimeZone,
  });

  const dateIntlOptions = getIntlDateOptions(formatString);
  dateIntlOptions.timeZone = userTimeZone;
  const dateIntlformater = new Intl.DateTimeFormat(undefined, dateIntlOptions);

  //get date separator as first occurrence of non alfa char
  let dateSeparator = '';

  const match = formatString.match(/[^a-z]/gi);
  if (match && match!.length > 0) {
    dateSeparator = formatString.match(/[^a-z]/gi)![0];
  }

  const dateIntlParts = dateIntlformater.formatToParts(dateToFormat);
  let dateParts: string[] = [];
  for (const [key] of Object.entries(dateIntlOptions)) {
    const dp = dateIntlParts.find((_) => _.type === key);
    dp && dateParts.push(dp?.value);
  }
  let formattedDate = dateParts.join(dateSeparator);

  if (includeTime === true || /m+|s+|H+|h+/g.test(formatString))
    formattedDate +=
      ' ' + timeintlformater.format(dateToFormat).replace('GMT', '');

  return formattedDate;
};

export const getIntlOptionValue = (part: string) => ({
  //option property name
  [part.includes('M') ? 'month' : part.includes('y') ? 'year' : 'day']:
    //option value
    part.length === 2
      ? '2-digit'
      : part.length === 3 && part.includes('M')
      ? 'short'
      : 'numeric',
});

export const getIntlDateOptions = (dateFormatString: string) => {
  // Regex to split date format string
  const parts = dateFormatString.match(/M+|d+|y+/g);

  if (!parts) return {};

  return parts.reduce((opts: any, part: string) => {
    return { ...opts, ...getIntlOptionValue(part) }; // Using spread operator instead of $.extend
  }, {});
};

export const formatDate = (date: Date): string => {
  const newDate = getBrowserDateShiftedToUserTZ(date).toISOString();

  return newDate;
};

export const getFormatHoursWithTimeZone = (hours: string[]): number[] => {
  return hours.map((el) => {
    const currentDate = new Date();
    const baseDate = new Date(currentDate.setHours(+el, 0, 0, 0));
    const hour = getBrowserDateShiftedToUserTZ(baseDate).getUTCHours();

    return +hour;
  });
};

export const getHourInLocalTimeZone = (hours: string[]): string[] => {
  return hours.map((el) => {
    const currentDate = new Date();
    const baseDate = new Date(currentDate.setUTCHours(+el, 0, 0, 0));

    return baseDate.getHours().toString();
  });
};
